"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailAttributes$ = exports.CompanyDetailAttributes$outboundSchema = exports.CompanyDetailAttributes$inboundSchema = void 0;
exports.companyDetailAttributesToJSON = companyDetailAttributesToJSON;
exports.companyDetailAttributesFromJSON = companyDetailAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const companiescompanyaccounts_js_1 = require("./companiescompanyaccounts.js");
const companiescompanycategory_js_1 = require("./companiescompanycategory.js");
const companiescompanylimitedpartnerships_js_1 = require("./companiescompanylimitedpartnerships.js");
const companiescompanymortgages_js_1 = require("./companiescompanymortgages.js");
const companiescompanypreviousnames_js_1 = require("./companiescompanypreviousnames.js");
const companiescompanyreturns_js_1 = require("./companiescompanyreturns.js");
const companiescompanystatus_js_1 = require("./companiescompanystatus.js");
const companydetailaddress_js_1 = require("./companydetailaddress.js");
/** @internal */
exports.CompanyDetailAttributes$inboundSchema = z.object({
    company_accounts: z.nullable(companiescompanyaccounts_js_1.CompaniesCompanyAccounts$inboundSchema),
    company_category: z.nullable(companiescompanycategory_js_1.CompaniesCompanyCategory$inboundSchema),
    company_mortgages: z.nullable(companiescompanymortgages_js_1.CompaniesCompanyMortgages$inboundSchema),
    company_name: z.string(),
    company_number: z.string(),
    company_returns: z.nullable(companiescompanyreturns_js_1.CompaniesCompanyReturns$inboundSchema),
    company_status: z.nullable(companiescompanystatus_js_1.CompaniesCompanyStatus$inboundSchema),
    confirmation_statement_last_made_up_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    confirmation_statement_next_due_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    country_of_origin: z.nullable(z.string()),
    dissolution_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    incorporation_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    is_society: z.nullable(z.boolean()),
    limited_partnerships: z.nullable(companiescompanylimitedpartnerships_js_1.CompaniesCompanyLimitedPartnerships$inboundSchema),
    previous_names: z.nullable(z.array(companiescompanypreviousnames_js_1.CompaniesCompanyPreviousNames$inboundSchema)),
    registered_address: z.nullable(companydetailaddress_js_1.CompanyDetailAddress$inboundSchema),
    sic_codes: z.nullable(z.array(z.string())),
    uri: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_accounts": "companyAccounts",
        "company_category": "companyCategory",
        "company_mortgages": "companyMortgages",
        "company_name": "companyName",
        "company_number": "companyNumber",
        "company_returns": "companyReturns",
        "company_status": "companyStatus",
        "confirmation_statement_last_made_up_date": "confirmationStatementLastMadeUpDate",
        "confirmation_statement_next_due_date": "confirmationStatementNextDueDate",
        "country_of_origin": "countryOfOrigin",
        "dissolution_date": "dissolutionDate",
        "incorporation_date": "incorporationDate",
        "is_society": "isSociety",
        "limited_partnerships": "limitedPartnerships",
        "previous_names": "previousNames",
        "registered_address": "registeredAddress",
        "sic_codes": "sicCodes",
    });
});
/** @internal */
exports.CompanyDetailAttributes$outboundSchema = z.object({
    companyAccounts: z.nullable(companiescompanyaccounts_js_1.CompaniesCompanyAccounts$outboundSchema),
    companyCategory: z.nullable(companiescompanycategory_js_1.CompaniesCompanyCategory$outboundSchema),
    companyMortgages: z.nullable(companiescompanymortgages_js_1.CompaniesCompanyMortgages$outboundSchema),
    companyName: z.string(),
    companyNumber: z.string(),
    companyReturns: z.nullable(companiescompanyreturns_js_1.CompaniesCompanyReturns$outboundSchema),
    companyStatus: z.nullable(companiescompanystatus_js_1.CompaniesCompanyStatus$outboundSchema),
    confirmationStatementLastMadeUpDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    confirmationStatementNextDueDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    countryOfOrigin: z.nullable(z.string()),
    dissolutionDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    incorporationDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    isSociety: z.nullable(z.boolean()),
    limitedPartnerships: z.nullable(companiescompanylimitedpartnerships_js_1.CompaniesCompanyLimitedPartnerships$outboundSchema),
    previousNames: z.nullable(z.array(companiescompanypreviousnames_js_1.CompaniesCompanyPreviousNames$outboundSchema)),
    registeredAddress: z.nullable(companydetailaddress_js_1.CompanyDetailAddress$outboundSchema),
    sicCodes: z.nullable(z.array(z.string())),
    uri: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyAccounts: "company_accounts",
        companyCategory: "company_category",
        companyMortgages: "company_mortgages",
        companyName: "company_name",
        companyNumber: "company_number",
        companyReturns: "company_returns",
        companyStatus: "company_status",
        confirmationStatementLastMadeUpDate: "confirmation_statement_last_made_up_date",
        confirmationStatementNextDueDate: "confirmation_statement_next_due_date",
        countryOfOrigin: "country_of_origin",
        dissolutionDate: "dissolution_date",
        incorporationDate: "incorporation_date",
        isSociety: "is_society",
        limitedPartnerships: "limited_partnerships",
        previousNames: "previous_names",
        registeredAddress: "registered_address",
        sicCodes: "sic_codes",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompanyDetailAttributes$;
(function (CompanyDetailAttributes$) {
    /** @deprecated use `CompanyDetailAttributes$inboundSchema` instead. */
    CompanyDetailAttributes$.inboundSchema = exports.CompanyDetailAttributes$inboundSchema;
    /** @deprecated use `CompanyDetailAttributes$outboundSchema` instead. */
    CompanyDetailAttributes$.outboundSchema = exports.CompanyDetailAttributes$outboundSchema;
})(CompanyDetailAttributes$ || (exports.CompanyDetailAttributes$ = CompanyDetailAttributes$ = {}));
function companyDetailAttributesToJSON(companyDetailAttributes) {
    return JSON.stringify(exports.CompanyDetailAttributes$outboundSchema.parse(companyDetailAttributes));
}
function companyDetailAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompanyDetailAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompanyDetailAttributes' from JSON`);
}
//# sourceMappingURL=companydetailattributes.js.map